import BasePage from "@Scripts/Pages/BasePage";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class InfoRequestPage extends BasePage {
    public static async init() {
        await super.init();

        this.setInfoRequest();
    }

    public static setInfoRequest() {
        var $form = $("#FormInfoRequest"),
            $successbox = $(".success-box");

        (<any>$form).ajaxForm({
            iframe: false,
            beforeSubmit: function (formData, jqForm, options) {
                $(".validation").hide();
                FormHelper.resetValidation($form);
                FormHelper.disableControls($form);
            },
            success: function (data) {
                FormHelper.resetValidation($form);
                $(".validation").hide();

                $form.hide();
                $successbox.show();

                GTagHelper.sendEvent("form_submit", { inforequest_form: "success" });
            },
            error: function (xhr, textStatus, errorThrown) {
                FormHelper.enableControls($form);
                FormHelper.setValidation($form, xhr.responseJSON);
                $(".validation").show();
            }
        });
    }
}